module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "device-embedded-information-bach-edit-modal",
    attrs: {
      "width": "460px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade"
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("本当に登録してよろしいでしょうか。")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body device-embedded-information-bach-edit-modal-body",
    staticStyle: {
      "height": "100px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("完了")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c0f1ba4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/device-embedded-information-add_check.vue
// module id = 982
// module chunks = 0